import CustomButton from "components/Atoms/CustomButton"
import { useCreateOrUpdateRouteMutation } from "generated/graphql"
import {
  ROUTE_LIST,
  SURVEY_AREA_VENDORS,
} from "graphql/routes/routes.queries.gql"
import { ROUTES } from "graphql/selector.queries.gql"
import React, { useMemo } from "react"
import { useNavigate } from "react-router-dom"
import AppToaster from "utils/AppToaster"
import useRouteStore from "../../routes.store"
import { ROUTE_MASTER_PAGE_SIZE } from "../list"
import useFSMWalkthrough from "../walkthrough.store"

const OutletListFooter = () => {
  const store = useRouteStore()
  const { setState, state } = useFSMWalkthrough()
  const surveyAreaId = store.data.surveyArea?.id

  const navigate = useNavigate()

  const [create, { loading }] = useCreateOrUpdateRouteMutation({
    onError({ message }) {
      AppToaster.show({ message, intent: "danger" })
    },
    onCompleted({ addUpdateRoute }) {
      AppToaster.show({
        message: `Route ${addUpdateRoute.route.name} saved successfully!`,
        intent: "success",
        icon: "tick",
      })
      store.reset()
      navigate("/d/fsm/routes")
    },
    refetchQueries: [
      {
        query: ROUTE_LIST,
        variables: {
          surveyAreaId: store.data.surveyArea?.id,
          first: 30,
        },
      },
      {
        query: ROUTES,
      },
      {
        query: ROUTE_LIST,
        variables: {
          first: ROUTE_MASTER_PAGE_SIZE,
          skip: 0,
        },
      },
      {
        query: SURVEY_AREA_VENDORS,
        variables: {
          surveyAreaId: surveyAreaId,
          first: 15,
        },
      },
    ],
  })

  const data = store.data
  const step = data.step
  const nextStep = store.nextStep
  const props = useMemo(() => {
    switch (step) {
      case "select":
        return {
          id: "fsm-route-create-sequence-button",
          text: "Create sequence for the outlets",
          onClick: () => {
            if (!data.name)
              return AppToaster.show({
                message: "Please enter a name for the route",
                intent: "danger",
              })
            nextStep()
            setState({ stepIndex: state.stepIndex + 1 })
          },
        }

      case "order":
        return {
          id: "fsm-route-save-button",
          text: data.id ? "Update" : "Create",
          onClick() {
            create({
              variables: {
                id: data.id,
                categoryId: data?.category?.id,
                surveyAreaId: data.surveyArea?.id,
                name: data.name,
                colorCode: data.colorCode?.id,
                points: data.selectedOutlets.map((outlet, index) => ({
                  sequence: (index + 1).toString(),
                  visiteeId: outlet.id,
                })),
              },
            })
            // Create route
          },
        }

      default:
        return null
    }
  }, [step, nextStep, data, create, state, setState])
  return (
    <footer className="bg-white p-2 flex justify-end shrink-0">
      {step === "order" && (
        <CustomButton
          id="fsm-route-preview-button"
          icon="map-marker"
          className="mr-2"
          text="Preview Route"
          onClick={() => {
            store.generatePreviewRoute()
            setTimeout(() => {
              setState({ stepIndex: state.stepIndex + 1 })
            }, 400)
          }}
        />
      )}
      <CustomButton intent="success" loading={loading} {...props} />
    </footer>
  )
}

export default OutletListFooter
